import { ResourceType } from '@repo/api-gw-sdk';

export const ZERO_ETL_SUPPORTED_RESOURCE_TYPES: ResourceType[] = [
  ResourceType.AwsEc2,
  ResourceType.AwsRds,
  ResourceType.AwsDynamoDb,
];
